export type SearchItem = { title: string; description: string; route: string; keywords: string }

export function searchItems(items: SearchItem[], input: string): SearchItem[] {
  const fold = (text: string) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd')
  const query = fold(input.trim())
  const rank = (item: SearchItem) => {
    if (!query) return 0
    const title = fold(item.title)
    return title === query ? 3 : title.startsWith(query) ? 2 : title.includes(query) ? 1 : 0
  }
  return items
    .filter(
      (item) => !query || fold(`${item.title} ${item.description} ${item.keywords}`).includes(query),
    )
    .sort((a, b) => rank(b) - rank(a))
    .slice(0, 8)
}
